/**
 * Created by Mohdan on 01.10.2026
 */

const OnePlusOneOfferLogic = function (offer) {
    OfferLogic.call(this, offer);
};

OnePlusOneOfferLogic.prototype = Object.create(OfferLogic.prototype);
OnePlusOneOfferLogic.prototype.constructor = OnePlusOneOfferLogic;

OnePlusOneOfferLogic.prototype.refresh = function () {
    OfferLogic.prototype.refresh.call(this);
    this.checkIfComplete();
};

OnePlusOneOfferLogic.prototype.getStage = function () {
    return this.offer.stage || 0;
};

OnePlusOneOfferLogic.prototype.getPaidRewards = function () {
    return this.getRewards();
};

OnePlusOneOfferLogic.prototype.getFreeRewards = function () {
    return this.config.freeReward;
};

OnePlusOneOfferLogic.prototype.getRestoreRewards = function () {
    return RewardsList.sumRewards(this.getRewards(), this.getFreeRewards());
};

OnePlusOneOfferLogic.prototype.getContext = function () {
    return {
        type: "oneplusone_offer",
        offer: this.offer.type,
        name: this.offer.name
    };
};

OnePlusOneOfferLogic.prototype.hasPendingRestore = function () {
    const purchase = cleverapps.paymentsLogic.pendingPurchaseToRestore;
    if (!purchase) {
        return false;
    }

    const context = connector.payments.getPaymentContext(purchase);
    return context && context.type === "oneplusone_offer" && context.offer === this.offer.type;
};

OnePlusOneOfferLogic.prototype.canBuy = function () {
    const product = this.getProduct();
    return this.getStage() === 0 && this.getTimeLeft() > 0 && !this.isBeingPurchased
        && !this.hasPendingRestore() && Boolean(product) && product.isAvailable();
};

OnePlusOneOfferLogic.prototype.canClaimFree = function () {
    return this.getStage() === 1;
};

OnePlusOneOfferLogic.prototype.hasIconAttention = function () {
    return this.canClaimFree();
};

OnePlusOneOfferLogic.prototype.needWait = function () {
    return this.canClaimFree() || this.isBeingPurchased;
};

OnePlusOneOfferLogic.prototype.checkIfComplete = function () {
    if (this.canClaimFree() && this.getTimeLeft() <= 0) {
        const rewards = new RewardsList(this.getFreeRewards(), {
            toBubbleStack: true,
            event: cleverapps.EVENTS.EARN.PURCHASE
        });
        rewards.receiveRewards();
        rewards.updateViewAmount();

        this.offer.complete();
    }
};

OnePlusOneOfferLogic.prototype.processBought = function (success) {
    if (!success) {
        delete this.isBeingPurchased;
        this.onPurchaseFinished(false);
        this.offer.checkCompletion();
        return;
    }

    const rewards = this.getPaidRewards();

    cleverapps.focusManager.display({
        focus: "RewardWindow",
        stack: true,
        action: (f) => {
            new RewardWindow(rewards, {
                toBubbleStack: true,
                event: cleverapps.EVENTS.EARN.PURCHASE
            });

            cleverapps.focusManager.onceNoWindowsListener = f;
        }
    });

    this.offer.incStage();
    cleverapps.offerManager.resetOfferIcon(this.offer);
    this.offer.logPurchase(this.getProduct());

    delete this.isBeingPurchased;

    this.onPurchaseFinished(true);
    this.checkIfComplete();
};

OnePlusOneOfferLogic.prototype.claimFree = function () {
    if (!this.canClaimFree()) {
        return;
    }

    const rewards = this.getFreeRewards();

    cleverapps.focusManager.display({
        focus: "RewardWindow",
        stack: true,
        action: (f) => {
            new RewardWindow(rewards, {
                toBubbleStack: true,
                event: cleverapps.EVENTS.EARN.PURCHASE
            });

            cleverapps.focusManager.onceNoWindowsListener = f;
        }
    });

    this.offer.complete();
};

Restorable.BY_TYPE.oneplusone_offer = new Restorable({
    location: Restorable.LocationOfferExpedition,
    find: Restorable.FindOffer,
    isOwned: (offer) => offer.logic.getStage() > 0,
    give: (offer) => offer.logic.processBought(true),
    boughtReward: OfferLogic.RestoreBoughtReward
});
